import { render, staticRenderFns } from "./SideBarPromo.vue?vue&type=template&id=6d9925fd&scoped=true&"
import script from "./SideBarPromo.vue?vue&type=script&lang=js&"
export * from "./SideBarPromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9925fd",
  null
  
)

export default component.exports